import { EnvConfig } from '../types';

export const config: EnvConfig = {
  env: 'prod',
  api: {
    baseUrl: 'https://app.alloyads.ai/api',
    version: 'v1',
  },
  license: {
    mui: '2104c20e2b7609b06903a598d1da8a9eTz0xMjIxMDIsRT0xNzk1MjE5MTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=',
  },
  looker: {
    reportTemplateId: '58b2fca4-dc23-4a3d-80dd-c7a0932ba1fe',
    pageId: 'rB8PD',
  },
  alloyPublicUrl: 'https://www.alloyads.ai/',
};
